<template>
  <div>
    <div class="demo-box">
      <div class="source">
        <slot></slot>
      </div>
      <div class="meta" ref="meta" :style="{height: active ? metaHeight : 0}">
        <div class="description">
          <slot name="description"></slot>
        </div>
        <slot name="meta"></slot>
      </div>
      <div class="demo-control" @click="active = !active">
        <i :class="icon">
          <small v-show="!active">&nbsp;显示代码</small>
          <small v-show="active">&nbsp;隐藏代码</small>
        </i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "demo",
  data() {
    return {
      active: false,
      metaHeight: 0
    };
  },
  computed: {
    icon() {
      const icon = this.active ? "top" : "bottom";
      return `el-icon-caret-${icon}`;
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.$refs.meta) {
        this.$refs.meta.style.height = "auto";
        this.metaHeight = this.$refs.meta.offsetHeight + "px";
        this.$refs.meta.style.height = 0;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.demo-box {
  border: 1px solid #eaecef;
  border-radius: 3px;
  transition: 0.2s;

  .source {
    padding: 20px;
  }

  .meta {
    background-color: #f6f6f6;
    border-top: 1px solid #eaecef;
    overflow: hidden;
    height: 0;
    transition: height 0.2s;
  }

  .description {
    padding: 10px 20px;
    box-sizing: border-box;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    font-size: 14px;
    line-height: 22px;
    color: #666;
    word-break: break-word;
    margin: 10px;
    background-color: #fff;
    p {
      margin: 0;
      line-height: 26px;
    }
  }

  .demo-control {
    border-top: 1px solid #eaecef;
    height: 44px;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    margin-top: -1px;
    color: #d3dce6;
    cursor: pointer;
    position: relative;

    i {
      font-size: 16px;
      line-height: 44px;
      transition: 0.3s;
      color: #aaa;
    }
    &:hover {
      background-color: #f1f8f5;
      i {
        color: #42b983;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/demo/demo.vue